import React, { createContext, useState, useEffect, useContext } from "react";

export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [bannerList, setBannnerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState("en");



  useEffect(() => {
    setLoading(true)
    let lang = localStorage.getItem("languageSet")
    lang = lang ? lang : 'en';

    if (lang == "ar") {
      import('../assets/styles/main.css')
    } else {
      import('../assets/styles/main.css')
    }
    setTimeout(() => setLoading(false), 200)
    setLanguage(lang)
  }, [])



  return (
    <AppStateContext.Provider
      value={{
        bannerList,
        loading,
        setLoading,
        language,
        setLanguage,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppStateContext);
};
